import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {Switch, Space} from "antd";

import {
    getAllFindingsMatrix,
    clear_finding_matrix,
    createFindingMatrix,
    CREATE_FINDING_MATRIX,
    updateFindingMatrix,
    UPDATE_FINDING_MATRIX
} from "../../../redux/findings_matrix";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";

const FindingsMatrix = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_findings_matrix = useSelector((state) => state.findings_matrix_module._get_all_findings_matrix);
    const _create_finding_matrix = useSelector((state) => state.findings_matrix_module._create_finding_matrix);
    const _update_finding_matrix = useSelector((state) => state.findings_matrix_module._update_finding_matrix);
    const _get_all_periodicities = useSelector((state) => state.periodicities_module._get_all_periodicities);
    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_findings_matrix.data.datos) {
            setData(_get_all_findings_matrix.data.datos);
        }
    }, [_get_all_findings_matrix]);
    

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);
    const [periodicities, setPeriodicities] = useState([]);
    const [worSheets, setWorSheets] = useState([]);

    useEffect(() => {
        if (_get_all_periodicities.data.datos) {
            setPeriodicities(_get_all_periodicities.data.datos);
        }
    }, [_get_all_periodicities]);

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            let v = _get_all_work_sheets.data.datos.filter(x => x.activo === true);
            setWorSheets(v);
        }
    }, [_get_all_work_sheets]);

    const [form, setForm] = useState({
        nombre: "",
        hoja_trabajo: "",
        id_hoja_trabajo: 0,
        periodicidad: "",
        id_periodicidad: 0,
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_findingsmatrix').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({
                            ...form, 
                            nombre: item.nombre, 
                            id_hoja_trabajo: item.id_hoja_trabajo, 
                            hoja_trabajo: item.hoja_trabajo, 
                            id_periodicidad: item.id_periodicidad,
                            periodicidad: item.periodicidad, 
                            activo: item.activo
                        });
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    useEffect(() => {
        if (_create_finding_matrix.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_finding_matrix(CREATE_FINDING_MATRIX));
            dispatch(getAllFindingsMatrix(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_finding_matrix.status !== 0) {
            dispatch(clear_finding_matrix(CREATE_FINDING_MATRIX));
            toast.error(_create_finding_matrix.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_finding_matrix, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_finding_matrix.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_finding_matrix(UPDATE_FINDING_MATRIX));
            dispatch(getAllFindingsMatrix(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_finding_matrix.status !== 0) {
            dispatch(clear_finding_matrix(UPDATE_FINDING_MATRIX));
            toast.error(_update_finding_matrix.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_finding_matrix, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createFindingMatrix(token, form));
        } else {
            dispatch(updateFindingMatrix(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Matriz de hallazgos", link: "/matriz de hallazgos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_findingsmatrix').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({
                                                ...form, 
                                                nombre: '', 
                                                id_hoja_trabajo: 0, 
                                                hoja_trabajo: '', 
                                                id_periodicidad: 0, 
                                                periodicidad: '',  
                                                activo: true
                                            });
                                            document.getElementById('id_periodicidad').selectedIndex = 0;
                                            document.getElementById('id_hoja_trabajo').selectedIndex = 0;
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "periodicidad",
                                                label: "Periodicidad",
                                                type: "text",
                                            },
                                            {
                                                name: "hoja_trabajo",
                                                label: "Hoja de trabajo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar '} matriz de hallazgo</h5>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Periodicidad</label>
                            <SelectInput
                                id="id_periodicidad"
                                label="periodicidad"
                                name="id_periodicidad"
                                value={form.id_periodicidad}
                                select={form.periodicidad}
                                onChange={handleChange}
                                options={periodicities ? periodicities.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <label>Hoja de trabajo</label>
                            <SelectInput
                                id="id_hoja_trabajo"
                                label="Hoja de trabajo"
                                name="id_hoja_trabajo"
                                value={form.id_hoja_trabajo}
                                select={form.hoja_trabajo}
                                onChange={handleChange}
                                options={worSheets ? worSheets.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        {id !== 0 &&
                            <div className="form-group">
                                <Space size={14} direction='horizontal'>
                                    <strong>Activo</strong>
                                    <Switch
                                        checked={form.activo}
                                        checkedChildren="SI"
                                        unCheckedChildren="NO"
                                        onChange={handleCheckedChange}
                                    />
                                </Space>
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default FindingsMatrix;
